import React, { Component } from 'react';
import { CssBaseline, Button, Snackbar, IconButton, SnackbarContent } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { connect } from 'react-redux';
import { closeSnackbar } from './actions/snackbarActions';
import { colors } from './styles'


import AuthOrApp from './AuthOrApp';

class Main extends Component {
    render() {
        return (
            <React.Fragment>
                <CssBaseline />
                <AuthOrApp />
                <Snackbar
                    key='tes'
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.props.action}
                    autoHideDuration={6000}
                    onClose={this.handleClose}
                    onExited={this.handleExited}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{this.props.message}</span>}
                    action={[
                        <Button key="undo" color="secondary" size="small" onClick={this.props.exec}>
                            {this.props.text}
                        </Button>,
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            // className={classes.close}
                            onClick={() => this.props.closeSnackbar()}
                        >
                            <CloseIcon />
                        </IconButton>,
                    ]}
                />
                <Snackbar
                    key='simple'
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.props.simple}
                    autoHideDuration={6000}
                    onClose={this.handleClose}
                    onExited={this.handleExited}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{this.props.message}</span>}
                    action={[

                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            // className={classes.close}
                            onClick={() => this.props.closeSnackbar()}
                        >
                            <CloseIcon />
                        </IconButton>,
                    ]}
                />
                <Snackbar
                    key='error'
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}

                    open={this.props.error}
                    autoHideDuration={6000}

                >
                    <SnackbarContent
                        style={{backgroundColor:colors.danger}}
                        aria-describedby="client-snackbar"
                        message={
                            <span id="client-snackbar">
                                {this.props.message}
                            </span>
                        }
                        action={[

                            <IconButton
                                key={'close'}
                                aria-label="Close"
                                color="inherit"
                                onClick={() => this.props.closeSnackbar()}
                            >
                                <CloseIcon />
                            </IconButton>,
                        ]}
                    />
                </Snackbar>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => ({
    action: state.snackbarReducer.action,
    simple: state.snackbarReducer.simple,
    error: state.snackbarReducer.error,
    message: state.snackbarReducer.message,
    exec: state.snackbarReducer.callback,
    text: state.snackbarReducer.callbackText,

})

const mapDispatchToProps = {
    closeSnackbar
};

export default connect(mapStateToProps, mapDispatchToProps)(Main)





// WEBPACK FOOTER //
// ./src/Main.js